module.exports = __webpack_public_path__ + "img/datacenter.877d73ac.jpg";